import * as ActionTypes from './actionTypes';
import apiActionCreator from '../../common/service/api/actionCreator';
import {buildErrorMessage} from '../../common/util/errorUtils';

export const fetchPriceFactorsProductCodes = () =>
  apiActionCreator({
    'endpoint': '/price-factors/product-codes',
    'authenticated': true,
    'types': [
      ActionTypes.FETCH_PRICE_FACTORS_PRODUCT_CODES_REQUEST,
      ActionTypes.FETCH_PRICE_FACTORS_PRODUCT_CODES_SUCCESS,
      [
        ActionTypes.FETCH_PRICE_FACTORS_PRODUCT_CODES_FAILED,
        (error) => buildErrorMessage(error),
      ],
    ],
    'microservice': 'part',
    'method': 'GET',
  });
